<div class="padding flex column fix-width">
	<b>Shot confirmed</b>
	<img class="pickup-image margin-bottom-small margin-top-small" src="assets/confirm.png" alt="Pickup ready" />

	<div class="bg-green padding-small white margin-bottom-small">All shots are approved. Would you confirm the order?</div>

	<div class="flex column end full-width margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Close
			</button>
			<button (click)="close(true)">
				<i class="fa-solid fa-check"></i>
				Yes, confirm order
			</button>
		</div>
	</div>
</div>
